export default "__VITE_ASSET__DvGVOh1H__"